import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";

import { computed, h } from 'vue';
const __default__ = {
  name: 'XToolbarItem'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    title: {
      type: [String, Function],
      required: true
    },
    icon: {
      type: [String, Object, Function],
      default: ''
    },
    hidden: {
      type: [Function, Boolean],
      default: false
    },
    loading: {
      type: [Function, Boolean],
      default: false
    },
    disabled: {
      type: [Boolean, Function],
      default: false
    },
    type: {
      type: String,
      default: 'default',
      validator(value, _) {
        return ['default', 'primary', 'ghost', 'dashed', 'danger', 'link', 'text'].includes(value);
      }
    },
    children: {
      type: Array,
      default: undefined
    },
    action: {
      type: [String, Function],
      default: ''
    }
  },
  emits: ['item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const IconView = computed(() => {
      if (!props.icon) {
        return null;
      }
      if (typeof props.icon === 'string') {
        return h('i', {
          class: props.icon
        });
      } else if (typeof props.icon === 'function' || typeof props.icon === 'object') {
        return props.icon;
      }
      return null;
    });

    /**
     * 按按文字
     * @type {ComputedRef<string>}
     */
    const buttonTitle = computed(() => {
      return typeof props.title === 'function' ? props.title() : props.title;
    });

    /**
     * 按扭状态
     * @type {ComputedRef<''|'primary'|'success'|'info'|'warning'|'error'|'danger'|null>}
     */
    const buttonStatus = computed(() => {
      if (props.danger) {
        return 'danger';
      }
      // antv 按扭类型转vxeui按扭status
      if (['ghost', 'link', 'text'].indexOf(props.type) !== -1) {
        return '';
      }
      if (['', 'primary', 'success', 'info', 'warning', 'error', 'danger'].indexOf(props.type) !== -1) {
        return props.type;
      }
      return null;
    });

    /**
     * 按扭模式
     * @type {ComputedRef<'text'|'button'>}
     */
    const buttonMode = computed(() => {
      if (['ghost', 'link', 'text'].indexOf(props.type) !== -1) {
        return 'text';
      }
      return 'button';
    });
    const buttonType = computed(() => {
      if (['submit', 'reset'].indexOf(props.type) !== -1) {
        return props.type;
      }
      return '';
    });
    const isHidden = computed(() => {
      return typeof props.hidden === 'function' ? props.hidden() : props.hidden;
    });
    const buttonLoading = computed(() => {
      return typeof props.loading === 'function' ? props.loading() : props.loading;
    });
    const buttonDisabled = computed(() => {
      return typeof props.disabled === 'function' ? props.disabled() : props.disabled;
    });
    const hasDropdownMenu = computed(() => {
      return !props.action && Array.isArray(props.children.value) && props.children.length > 0;
    });
    const isDropdownButton = computed(() => {
      return !!props.action && Array.isArray(props.children) && props.children.length > 0;
    });
    const buttonOptions = computed(() => {
      if (!props.children || !Array.isArray(props.children) || props.children.length === 0) {
        return null;
      }
      return (props.children || []).map(item => {
        const {
          title,
          icon,
          loading,
          disabled,
          type,
          action
        } = item || {};
        if (!title) return null;
        return {
          action,
          content: computed(() => {
            if (typeof title === 'function') {
              return title();
            }
            return title;
          }),
          mode: 'text',
          type: computed(() => {
            if (['submit', 'reset'].indexOf(type) !== -1) {
              return type;
            }
            return '';
          }),
          status: computed(() => {
            if (['', 'primary', 'success', 'warning', 'error', 'danger', 'warning'].indexOf(type) !== -1) {
              return type;
            }
            if (['ghost', 'link', 'text'].indexOf(type) !== -1) {
              return '';
            }
            return null;
          }),
          icon: computed(() => {
            if (!!icon && typeof icon === 'function') {
              return icon();
            } else if (!!icon && typeof icon === 'string') {
              return icon;
            }
            return '';
          }),
          loading: computed(() => {
            if (typeof loading === 'function') {
              return loading();
            }
            return loading;
          }),
          disabled: computed(() => {
            if (typeof disabled === 'function') {
              return disabled();
            }
            return disabled;
          })
        };
      }).filter(t => !!t);
    });
    const handleButtonClick = () => {
      emit('item-click', {
        ...props
      });
    };
    const handleDropdownClick = ({
      option
    }) => {
      emit('item-click', option);
    };
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      return _unref(isDropdownButton) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!_unref(isHidden) ? (_openBlock(), _createBlock(_component_vxe_button_group, {
        key: 0,
        round: false
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_button, {
          disabled: _unref(buttonDisabled),
          loading: _unref(buttonLoading),
          status: _unref(buttonStatus),
          mode: _unref(buttonMode),
          type: _unref(buttonType),
          onClick: handleButtonClick
        }, _createSlots({
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(buttonTitle)), 1)]),
          _: 2
        }, [!!__props.icon ? {
          name: "icon",
          fn: _withCtx(() => [_createVNode(_unref(IconView))]),
          key: "0"
        } : undefined]), 1032, ["disabled", "loading", "status", "mode", "type"]), _createVNode(_component_vxe_button, {
          disabled: _unref(buttonDisabled),
          options: _unref(buttonOptions),
          onDropdownClick: handleDropdownClick
        }, null, 8, ["disabled", "options"])]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : _unref(hasDropdownMenu) ? (_openBlock(), _createBlock(_component_vxe_button, {
        key: 1,
        loading: _unref(buttonLoading),
        disabled: _unref(buttonDisabled),
        mode: _unref(buttonMode),
        type: _unref(buttonType),
        round: false,
        options: _unref(buttonOptions),
        onDropdownClick: handleDropdownClick
      }, _createSlots({
        _: 2
      }, [!!__props.icon ? {
        name: "icon",
        fn: _withCtx(() => [_createVNode(_unref(IconView))]),
        key: "0"
      } : undefined]), 1032, ["loading", "disabled", "mode", "type", "options"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [!_unref(isHidden) ? (_openBlock(), _createBlock(_component_vxe_button, {
        key: 0,
        status: _unref(buttonStatus),
        mode: _unref(buttonMode),
        type: _unref(buttonType),
        loading: _unref(buttonLoading),
        disabled: _unref(buttonDisabled),
        round: false,
        onClick: handleButtonClick
      }, _createSlots({
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(buttonTitle)), 1)]),
        _: 2
      }, [!!__props.icon ? {
        name: "icon",
        fn: _withCtx(() => [_createVNode(_unref(IconView))]),
        key: "0"
      } : undefined]), 1032, ["status", "mode", "type", "loading", "disabled"])) : _createCommentVNode("", true)], 64));
    };
  }
});